import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

// const estimatedBillSummary = Loadable(() => import('../../containers/web/estimatedBillSummary'));
const estimatedBillSummary = Loadable(() => import('../../containers/web/nextBillSummary'));

export default MapTo('vcg/components/soe-home/react/estimatedBillSummaryVds')(estimatedBillSummary);
